import angular from 'angular';
import template from './qrcode.jade';
import qrcode from 'qrcode-generator';

export class QrCodeController {
    /* @ngInject */
    constructor($element, $scope) {
        this.$element = $element;

        $scope.$watchGroup(
            ['vm.link', 'vm.show', 'vm.typeNumber', 'vm.errorCorrectionLevel'],
            () => this.renderQr()
        );
    }

    renderQr() {
        const container = this.$element[0].querySelector('#qr-inner');
        if (!this.show || !this.link || !container) {
            return;
        }

        container.innerHTML = '';

        try {
            const typeNumber = parseInt(this.typeNumber || '0');
            const errorCorrectionLevel = this.errorCorrectionLevel || 'L';

            const qr = qrcode(typeNumber, errorCorrectionLevel);
            qr.addData(this.link);
            qr.make();

            container.innerHTML = qr.createImgTag(4);
        } catch (err) {
            console.error('QR generation failed', err);
        }
    }
}

export function QrCodeComponent() {
    return {
        restrict: 'E',
        template,
        controller: QrCodeController,
        controllerAs: 'vm',
        bindToController: true,
        scope: {
            link: '=',
            show: '<',
            error: '<',
            typeNumber: '@',
            errorCorrectionLevel: '@'
        }
    };
}

export default angular
    .module('qrCode', [])
    .directive('qrCode', QrCodeComponent);



/** WEBPACK FOOTER **
 ** ./src/components/account/qrcode/qrcode.js
 **/